import { SERVICES } from "@/data/services";

export default function Marquee() {
  const items = SERVICES.map((s) => s.title);
  const Row = ({ hidden = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((title) => (
        <span key={title} className="flex items-center">
          <span className="whitespace-nowrap px-6 text-sm font-medium uppercase tracking-[0.14em] text-white">
            {title}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <section className="relative z-10 overflow-hidden bg-navy-900 py-3" data-testid="services-marquee">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
